<div class="collapsible-group-container">
  <div class="interactive-item" (click)="onGroupHeaderClick()" (mouseenter)="onGroupHeaderEnter()" (mouseleave)="onGroupHeaderLeave()">
    <div class="interactive-item__content">
      <div class="interactive-item__prefix">
        <button class="interactive-item__button interactive-item__button--hovering" mat-icon-button (click)="toggleExpand($event)" [attr.aria-expanded]="isExpanded()" aria-label="Toggle expansion">
          <mat-icon>{{ isExpanded() ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
        @if (groupIcon && !isSvgIcon) {
          <mat-icon class="interactive-item__icon" aria-hidden="true">{{ groupIcon }}</mat-icon>
        }
        @if (groupIcon && isSvgIcon) {
          <mat-icon class="interactive-item__icon" [svgIcon]="groupIcon" aria-hidden="true" />
        }
      </div>

      <span #groupTextElement class="interactive-item__text" [matTooltip]="groupText" matTooltipPosition="above" matTooltipShowDelay="2000" matTooltipHideDelay="300">
        {{ groupText }}
      </span>
    </div>

    @if (buttons && buttons.length > 0) {
      <div class="interactive-item__actions">
        <button mat-icon-button (click)="onGroupOptionsClick($event, optionsButton)" #optionsButton class="interactive-item__button" aria-label="More options">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <button mat-icon-button (click)="onGroupAddClick($event)" class="interactive-item__button" aria-label="Add item">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    }
  </div>

  <div class="group-children-content" [@collapseExpand]="isExpanded() ? 'expanded' : 'collapsed'">
    <ng-content></ng-content>
  </div>
</div>
